const acceptedExtensions = ['kml', 'kmz']

export const isExtensionAccepted = (fileName: string) => {
  const ext = fileName.split('.').pop()
  return acceptedExtensions.includes(ext)
}
